export default "__VITE_ASSET__C2tNzr79__"